import { buildModelsActionCreator } from './build-models-action-creator';

export const FETCH_HELP_CENTER_MODEL = 'epic.model.FETCH_HELP_CENTER_MODEL';
export const FETCH_HELP_CENTER_BRANDING_MODEL = 'epic.model.FETCH_HELP_CENTER_BRANDING_MODEL';

export type FetchHelpCenterAction = ReturnType<typeof fetchHelpCenterAction>;
export type FetchHelpCenterBrandingAction = ReturnType<typeof fetchHelpCenterBrandingAction>;

export const fetchHelpCenterAction = buildModelsActionCreator(FETCH_HELP_CENTER_MODEL, 'sharedPortal');

export const fetchHelpCenterBrandingAction = buildModelsActionCreator(
    FETCH_HELP_CENTER_BRANDING_MODEL,
    'helpCenterBranding'
);
